import {
  CognitoUser,
  AuthenticationDetails,
  ICognitoUserData,
} from 'amazon-cognito-identity-js';
import { Amplify } from '@aws-amplify/core';
import { Auth } from '@aws-amplify/auth';
import { Http } from 'library';
import { httpMethods } from 'enums';
import * as Endpoints from 'constants/endpoints.constant';
import { EntUserPool, UserPool } from './UserPool';

Amplify.configure({
  Auth: {
    // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
    identityPoolId: '',

    // REQUIRED - Amazon Cognito Region
    region: process.env.REACT_APP_AWS_REGION,

    // OPTIONAL - Amazon Cognito Federated Identity Pool Region
    // Required only if it's different from Amazon Cognito Region
    identityPoolRegion: process.env.REACT_APP_AWS_REGION,

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: process.env.REACT_APP_CLIENT_ID,

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: process.env.REACT_APP_API_KEY,

    authenticationFlowType: 'CUSTOM_AUTH',
  },
});

/* eslint-disable */
class LoginService {
  /**
   * Login
   * @param username
   * @param password
   */
  static async login(username: string, password: string) {
    const user: CognitoUser = new CognitoUser({
      Username: username,
      Pool: UserPool,
    });

    const authDetails = new AuthenticationDetails({
      Username: username,
      Password: password,
    });
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      user.authenticateUser(authDetails, {
        onSuccess: (data) => {
          resolve(data);
        },

        onFailure: (err) => {
          reject(err);
        },
        newPasswordRequired: (userAtr, required) => {
          delete userAtr.email_verified;
          delete userAtr.phone_number_verified;
          resolve({ changeRequired: true, user, userAtr, required });
        },
      });
    });
  }
  /**
   * Force Change password
   * @param username
   * @param password
   */
  static async forceChangePassword(
    userAttr: any,
    cognitoUser: CognitoUser,
    password: string
  ) {
    let params = {
      ...userAttr,
      given_name: userAttr.given_name,
      family_name: userAttr.family_name,
      phone_number: userAttr.phoneNumber,
    };

    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      cognitoUser.completeNewPasswordChallenge(password, params, {
        onSuccess: (data) => {
          resolve(data);
        },

        onFailure: (err) => {
          reject(err);
        },
      });
    });
  }

  /**
   * Login
   * @param username
   * @param password
   */
  static async entLogin(username: string, password: string) {
    const user: CognitoUser = new CognitoUser({
      Username: username,
      Pool: EntUserPool,
    });

    const authDetails = new AuthenticationDetails({
      Username: username,
      Password: password,
    });
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      user.authenticateUser(authDetails, {
        onSuccess: (data) => {
          resolve(data);
        },

        onFailure: (err) => {
          reject(err);
        },
      });
    });
  }

  static async generateLoginOtp(username: string) {
    return new Promise(async (resolve, reject) => {
      Auth.signIn(username)
        .then((user) => {
          resolve(user);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  static async verifyLoginOtp(username: string, otp: string) {
    return new Promise(async (resolve, reject) => {
      Auth.sendCustomChallengeAnswer(username, otp)
        .then((user) => {
          resolve(user);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  static async changePassword(
    username: any,
    oldPassword: any,
    newPassword: any
  ) {
    const user: CognitoUser = new CognitoUser({
      Username: username,
      Pool: UserPool,
    });
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      user.getSession(function (err, session) {
        if (err) {
          reject(err);
          return;
        }
      });
      user.changePassword(oldPassword, newPassword, function (err, result) {
        if (err) {
          reject(err);
          return;
        }
        resolve(result);
      });
    });
  }
  static async entChangePassword(
    username: any,
    oldPassword: any,
    newPassword: any
  ) {
    const user: CognitoUser = new CognitoUser({
      Username: username,
      Pool: EntUserPool,
    });
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      user.getSession(function (err, session) {
        if (err) {
          reject(err);
          return;
        }
      });
      user.changePassword(oldPassword, newPassword, function (err, result) {
        if (err) {
          reject(err);
          return;
        }
        resolve(result);
      });
    });
  }

  /**
   * sendOTP
   * @param username
   */
  static async sendOTP(username: any) {
    const user: CognitoUser = new CognitoUser({
      Username: username,
      Pool: UserPool,
    });

    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      user.resendConfirmationCode(function (err, result) {
        if (err) {
          reject(err);
          return;
        }
        resolve(result);
      });
    });
  }

  /**
   * sendOTP
   * @param username
   */
  static async entSendOTP(username: any) {
    const user: CognitoUser = new CognitoUser({
      Username: username,
      Pool: EntUserPool,
    });

    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      user.resendConfirmationCode(function (err, result) {
        if (err) {
          reject(err);
          return;
        }
        resolve(result);
      });
    });
  }

  /**
   * verifyOTP
   * @param username
   * @param otp
   */
  static async verifyOTP(username: any, otp: any) {
    const user: CognitoUser = new CognitoUser({
      Username: username,
      Pool: UserPool,
    });
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      user.confirmRegistration(otp, true, function (err, result) {
        if (err) {
          reject(err);
          return;
        }
        resolve(result);
      });
    });
  }

  /**
   * verifyOTP
   * @param username
   * @param otp
   */
  static async verifyEntOTP(username: any, otp: any) {
    const user: CognitoUser = new CognitoUser({
      Username: username,
      Pool: EntUserPool,
    });
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      user.confirmRegistration(otp, true, function (err, result) {
        if (err) {
          reject(err);
          return;
        }
        resolve(result);
      });
    });
  }

  static sendOTPToEmail = async (token: any = '', accessToken: any = '') =>
    Http.setMethod(httpMethods.get)
      .setUrl(`${Endpoints.SEND_OTP}`)
      .setToken(token)
      .setAccessToken(accessToken)
      .request();

  static verifyMailOtp = async (
    data: any,
    token: any = '',
    accessToken: any = ''
  ) =>
    Http.setMethod(httpMethods.post)
      .setData(data)
      .setUrl(`${Endpoints.VERIFY_OTP}`)
      .setToken(token)
      .setAccessToken(accessToken)
      .request();

  static updateUser = async (userId: any, data: any, token: any) =>
    Http.setMethod(httpMethods.patch)
      .setData(data)
      .setUrl(`${Endpoints.UPDATE_USER}/${userId}`)
      .setToken(token)
      .request();

  //STORE FCM TOKEN ON LOGIN
  static storeFcmToken = async (data: any) =>
    Http.setMethod(httpMethods.post)
      .setData(data)
      .setUrl(`${Endpoints.STORE_FCM_TOKEN}`)
      // .setToken(token)
      .request();

  /**
   * Patch user's mobile and email as verified
   * @param data
   * @returns response
   */
  static verifyB2bUser = async (
    data: any,
    token: any = '',
    accessToken: any = ''
  ) =>
    Http.setMethod(httpMethods.post)
      .setData(data)
      .setUrl(`${Endpoints.B2B_VERIFY}`)
      .setToken(token)
      .setAccessToken(accessToken)
      .request();

  static isValidReferralCode = async (code) =>
    Http.setMethod(httpMethods.get)
      .unsetData()
      .setUrl(`${Endpoints.IS_VALID_REFCODE}?referralCode=${code}`)
      .request();
}

export default LoginService;
